import React, { useState, useEffect } from 'react';
import { Layout } from '../layout/Layout';
import Loading from '../based/Loading';
import { CONSTANTS, INITPAGING } from '../based/Constants';
import { NOTIFY } from '../based/Constants';
import { Notify } from '../based/Notify';
import CommonTable from '../based/CommonTable';
import AnalyticServices from '../based/services/AnalyticServices';
import Request from '../based/Request';
import TFUDatetime from '../based/inputs/TFUDatetime';
import Common from '../based/Common';


export default function KeywordManagement(props) {
    const [isBusy, setBusy] = useState(true)
    const [datas, setDatas] = useState([]);
    const [paging, setPaging] = useState({ ...INITPAGING, fromDate: new Date(), toDate: new Date() });

    useEffect(() => {
        setBusy(false)
        getDatas(paging)
    }, [])

    async function getDatas(newPaging) {
        setBusy(true)
        const [err, data] = await AnalyticServices.GetSearchByPaging(newPaging);
        if (!err) {
            setDatas(data.listObjects);
            setPaging(data.paging);
            setBusy(false)
        } else {
            setPaging(newPaging);
            setDatas([]);
            setBusy(false)
        }
    }

    async function exportExcel(newPaging) {
        let [err, data] = await AnalyticServices.ExportSearchExcel(newPaging)
        if (!err) {
            let fileName = data.fileName;
            window.open(`${Request.API_URL}/api/analytic/download-file/${fileName}`, '_blank')
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, CONSTANTS.MSG_ERROR)
        }
    }

    async function exportExcelSearch(newPaging) {
        let [err, data] = await AnalyticServices.ExportSearchTrafficExcel(newPaging)
        if (!err) {
            let fileName = data.fileName;
            window.open(`${Request.API_URL}/api/analytic/download-file/${fileName}`, '_blank')
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, CONSTANTS.MSG_ERROR)
        }
    }

    function _renderAction() {
        return <div className='row flex-row p-10 box__actions align-items-end'>
            <div className='form-group ml-3'>
                <label htmlFor="fromDate" className="required">Từ ngày:</label>
                <TFUDatetime
                    dateFormat='dd/MM/yyyy'
                    name='fromDate'
                    value={new Date(paging.fromDate)}
                    onChanged={(selectedDate) => setPaging({ ...paging, fromDate: new Date(selectedDate) })}
                />
            </div>
            <div className='form-group ml-3'>
                <label htmlFor="toDate" className="required">Đến ngày:</label>
                <TFUDatetime
                    dateFormat='dd/MM/yyyy'
                    name='toDate'
                    value={new Date(paging.toDate)}
                    onChanged={(selectedDate) => setPaging({ ...paging, toDate: new Date(selectedDate) })}
                />
            </div>
            <div className="form-group ml-3">
                <button className='btn btn-primary' onClick={(e) => { e.preventDefault(); getDatas({ ...paging }) }}>Tìm kiếm</button>
            </div>
            <div className="form-group ml-3">
                <button className={`btn btn-primary ${!datas ? 'disabled' : ''}`} onClick={(e) => { e.preventDefault(); exportExcel({ ...paging }) }}>Xuất file detail</button>
            </div>
            <div className="form-group ml-3">
                <button className={`btn btn-primary ${!datas ? 'disabled' : ''}`} onClick={(e) => { e.preventDefault(); exportExcelSearch({ ...paging }) }}>Xuất file traffic</button>
            </div>
        </div>
    }


    function _renderHeader() {
        return (
            <thead>
                <tr>
                    <th className='center'>UUID</th>
                    <th className='center'>TimeSearch</th>
                    <th className='center'>Tên User (Nếu có đăng nhập)</th>
                    <th className='center'>Địa chỉ IP</th>
                    <th className='center'>Thông tin thiết bị</th>
                    <th className='center'>Thông tin tìm kiếm</th>
                </tr>
            </thead>
        )
    }

    function _renderBody() {
        return datas && datas.length > 0
            ? <tbody>
                {
                    datas.map((item, i) => {
                        return <tr key={i} >
                            <td>{item.uuid}</td>
                            <td>{Common.formatDate(new Date(item.timeSearch),'fulldate') }</td>
                            <td>{item.userName}</td>
                            <td>{item.ipInfo}</td>
                            <td>{item.deviceInfo}</td>
                            <td>
                                <span>
                                    <p>Từ khóa: {item.keyword}</p>
                                    <p>Thương hiệu: {item.brandName}</p>
                                    <p>Ngành hàng: {item.categoryName}</p>
                                    <p>Tỉnh: {item.provinceName}</p>
                                </span>
                            </td>
                        </tr>
                    })
                }
            </tbody>
            : <tbody><tr><td colSpan='6' className='center'>Không có dữ liệu</td></tr></tbody>
    }

    return (
        <React.Fragment>
            <Loading show={isBusy} msg={'Đang tải dữ liệu...'} />
            <CommonTable
                data={datas}
                paging={paging}
                searchBasic
                renderAction={_renderAction}
                renderHeader={_renderHeader}
                renderBody={_renderBody}
                onFilter={getDatas}
            />
        </React.Fragment>
    );
}
